import {DateTimeFormatter} from "@js-joda/core";

export const DEFAULT_DATE_PATTERN = "yyyy-MM-dd HH:mm";
export const DEFAULT_DATE_FORMATTER = DateTimeFormatter.ofPattern(DEFAULT_DATE_PATTERN);

export const taskExecutorQueues = [
    {
        value: "DEFAULT",
        label: "Default"
    },
    {
        value: "FAST_COMPUTE",
        label: "Fast Compute"
    },
]

